import React, { useEffect } from "react";
import Page from "../../../components/Page";
import LearnMCSessionPage from "./LearnMCSessionPage";
import { getActiveHeader } from "../../../redux/home/actions";
import { useDispatch } from "react-redux";

const NewLearnMCWorkshopPage = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getActiveHeader("events-list"));
  }, []);
  return (
    <Page>
      <div className="bannersection">
        <div className="container mt-5">
          <LearnMCSessionPage isEvents={false} />
        </div>
      </div>
    </Page>
  );
};

export default NewLearnMCWorkshopPage;
